import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import useDynamicCallback from "@mapmycustomers/shared/util/hook/useDynamicCallback";

import { doesOrganizationSupportSavedLocations } from "@app/store/iam";
import { areSavedAddressesLoaded } from "@app/store/savedLocations";
import { fetchSavedAddresses } from "@app/store/savedLocations/actions";

// Recovers from a failed start-up load, or the add-on turned on mid-session.
// A sign-in or sign-out resets the list too, and start-up asks for it then.
const useSavedAddressesRequest = () => {
  const dispatch = useDispatch();
  const supported = useSelector(doesOrganizationSupportSavedLocations);
  const loaded = useSelector(areSavedAddressesLoaded);
  const isLoaded = useDynamicCallback(() => loaded);

  useEffect(() => {
    if (supported && !isLoaded()) {
      dispatch(fetchSavedAddresses.request());
    }
  }, [dispatch, isLoaded, supported]);
};

export default useSavedAddressesRequest;
